import {useEffect, useState} from 'react'

import type {RefObject} from 'react'

interface UseContainerQueryParams {
  containerRef: RefObject<HTMLElement>
  width: number
}

export const useContainerQuery = ({containerRef, width}: UseContainerQueryParams): boolean => {
  const [isContainerAtLeastWidth, setIsContainerAtLeastWidth] = useState(true)
  useEffect(() => {
    const elementToObserve = containerRef.current
    if (elementToObserve === null) return

    const observer =  new ResizeObserver((entries) => {
      const entry = entries[0]
      if (entry === undefined) return
      setIsContainerAtLeastWidth(entry.contentRect.width >= width)
    })

    observer.observe(elementToObserve)
    return () => {
      observer.unobserve(elementToObserve)
    }
  }, [containerRef, width])
  return isContainerAtLeastWidth
}
